module.exports = __webpack_public_path__ + "img/logo.d913704c.svg";